import React, { useContext } from "react";
import { FreeformBracketConnectorsProps } from "bracket-system/types";
import { matchContext } from "bracket-system/core/match-context";
import FreeformConnectorService from "./freeform-connector-service";
import { findFreeformBracketMatchById } from "common/helpers/bracketHelper";

const FreeformBracketConnectors = ({
    matches,
    calculatedStyles,
}: FreeformBracketConnectorsProps) => {
    const {
        state: { hoveredPartyId },
    } = useContext(matchContext);
    const { connectorColor, connectorColorHighlight } = calculatedStyles;

    const connectors: { path: string; highlighted: boolean }[] = [];
    matches?.forEach((part) => {
        part.columns?.forEach((c, colIndex) => {
            const nextColIndex = colIndex + 1;
            let nextColumn = null;
            if (part.columns?.length > nextColIndex + 1) {
                nextColumn = part.columns[nextColIndex];
            }

            c.matches?.forEach((m) => {
                if (!m.nextMatchId) {
                    return;
                }

                const directFeed =
                    nextColumn?.matches?.length == c.matches?.length;

                // DO NOT CONNECT CROSS PARTS
                const nextMatch = findFreeformBracketMatchById(
                    matches,
                    m.nextMatchId
                );
                if (nextMatch.part != m.part) {
                    return;
                }

                const from =
                    FreeformConnectorService.getMatchConnectorLocation(
                        m.id,
                        "out"
                    );
                let to = FreeformConnectorService.getMatchConnectorLocation(
                    m.nextMatchId,
                    "in"
                );

                if (directFeed) {
                    to = { x: to.x, y: from.y };
                }

                const halfX = Math.floor((from.x + to.x) / 2);
                const path = `M ${from.x} ${from.y} L ${halfX} ${from.y} L ${halfX} ${to.y} L ${to.x} ${to.y}`;

                const highlighted =
                    hoveredPartyId != null &&
                    m.participants?.some((p) => p.id === hoveredPartyId) &&
                    nextMatch.participants?.some(
                        (p) => p.id === hoveredPartyId
                    );

                connectors.push({ path, highlighted: !!highlighted });
            });
        });
    });

    // SVG paints in document order; render highlighted paths last so they stay on top.
    connectors.sort((a, b) => Number(a.highlighted) - Number(b.highlighted));

    return (
        <>
            {connectors.map((c, i) => (
                <path
                    key={i}
                    d={c.path}
                    stroke={
                        c.highlighted ? connectorColorHighlight : connectorColor
                    }
                    fill="transparent"
                />
            ))}
        </>
    );
};

export default FreeformBracketConnectors;
